module.exports = __webpack_public_path__ + "img/img31.57b3bdd4.svg";